import React from 'react';
import qboStyles from './Qbo.styles';
import Config from '../../../../config.web';

const QboInstruction = () => {
    return (
        <>
            <div style={qboStyles.container}>
                <div style={qboStyles.instructionCard}>
                    <strong style={qboStyles.strong}>INSTRUCTIONS : </strong>
                    <ul style={qboStyles.ul}>
                        <li style={qboStyles.li}><span style={qboStyles.bullet}>•</span>Import your QuickBooks Vendor and payment info directly by selecting the year, form type and clicking "Import" below.</li>
                        <li style={qboStyles.li}><span style={qboStyles.bullet}>•</span>{Config.APP_BASE_URL} will import only 1099-qualified vendors.</li>
                    </ul>
                </div>
            </div>
        </>
    );
};
export default QboInstruction;